module.exports = __webpack_public_path__ + "static/img/Binyou_Wang.a42e634.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people/Binyou_Wang.png
// module id = BWmG
// module chunks = 1